import { gql } from "@apollo/client";
import { composeResolvers } from "@graphql-tools/resolvers-composition";

import { inquiry } from "@/lib/mailTemplate";
import sendEmail from "@/lib/sendEmail";

export const typeDef = gql`
  type Result {
    result: Boolean
  }
  type Mutation {
    sendInquiryMail(
      name: String!
      mailAddress: String!
      membersId: String
      pastSpooxId: String
      subject: String!
      body: String!
      comment: String!
    ): Result
  }
`;

export const resolvers = composeResolvers(
  {
    Mutation: {
      sendInquiryMail: async (
        _parent,
        { name, mailAddress, membersId, pastSpooxId, subject, body, comment },
        {}
      ) => {
        await sendEmail(
          inquiry({
            name,
            address: mailAddress,
            membersId,
            pastSpooxId,
            subject,
            body,
            comment,
          })
        );

        return { result: true };
      },
    },
    User: {
      __resolveType(user) {
        switch (user.type) {
          case "account":
            return "AccountUser";
          case "profile":
            return "ProfileUser";
        }
        return "User";
      },
    },
  },
  {}
);
